import styled from 'styled-components';
import { blueColor } from 'js/config/style';
import { lineHeight, verticalPadding, horizontalPadding } from 'js/components/common/Button/style';

export default styled.a`
  display: inline-block;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  background: transparent;
  color: ${blueColor};
  box-shadow: none;
  border: 1px solid ${blueColor};
  line-height: ${lineHeight}rem;
  padding: ${verticalPadding}rem ${horizontalPadding}rem;
  border-radius: 0.25rem;
  cursor: pointer;
  font-weight: 500;
  margin-top: 1rem;

  &:hover {
    text-decoration: none;
  }

  &:active,
  &:focus {
    border: 1px solid ${blueColor};
  }
`;
